import Vue from 'vue'

import Router from 'vue-router'

import Message from '@/components/Message'
import Upload from '@/views/page/Upload'
import Gallery from '@/views/page/Gallery'
import Photo from '@/views/page/Photo'

import Login from '@/views/user/Login';
import Lost from '@/views/user/Lost';
import PasswordReset from '@/views/user/PasswordReset';
import PasswordResetConfirm from '@/views/user/PasswordResetConfirm';
import Profile from '@/views/user/Profile';
import Register from '@/views/user/Register';
import VerifyEmail from '@/views/user/VerifyEmail';

import store from './store';

const requireAuthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (!store.getters['auth/isAuthenticated']) {
        next('/login');
      } else {
        next()
      }
    });
};

const requireUnauthenticated = (to, from, next) => {
  store.dispatch('auth/initialize')
    .then(() => {
      if (store.getters['auth/isAuthenticated']) {
        next('/home');
      } else {
        next();
      }
    });
};

const redirectLogout = (to, from, next) => {
  store.dispatch('auth/logout')
    .then(() => next('/login'));
};

Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: "/street"
    },
    {
      path: '/message',
      name: 'message',
      component: Message,
      beforeEnter: requireAuthenticated,
    },
    {
      path: '/upload',
      name: 'upload',
      component: Upload,
      beforeEnter: requireAuthenticated,
    },
    {
      path: '/users/:id/image/:image_id',
      name: 'image',
      component: Photo,
      beforeEnter: requireAuthenticated,
      props: true
    },
    {
      path: '/street',
      name: 'street-genre',
      component: Gallery,
      beforeEnter: requireAuthenticated,
      props: {user: false}
    },
    {
      path: '/users/:id',
      name: 'user-gallery',
      component: Gallery,
      beforeEnter: requireAuthenticated,
      props: { displayMode: 'user' }
    },
    {
      path: '/collectives/:id',
      name: 'collective-gallery',
      component: Gallery,
      beforeEnter: requireAuthenticated,
      props: { 
        displayMode: 'collective' 
      }
    },
    {
      path: '/projects/:id',
      name: 'project-gallery',
      component: Gallery,
      beforeEnter: requireAuthenticated,
      props: { displayMode: 'project' }
    },
    {
      path: '/password_reset',
      component: PasswordReset,
    },
    {
      path: '/password_reset/:uid/:token',
      component: PasswordResetConfirm,
    },
    {
      path: '/register',
      component: Register,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter: requireAuthenticated
    },
    {
      path: '/register/:key',
      component: VerifyEmail,
    },
    {
      path: '/login',
      component: Login,
      beforeEnter: requireUnauthenticated,
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: redirectLogout,
    },
    {
      path: '*',
      component: Lost,
    },
  ]
})
